import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { WorkflowAgent, WorkflowEvaluationSet, WorkflowEvaluationRun, ExecuteEvaluationRunRequest } from '../../types/generated.types';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';

@Injectable({ providedIn: 'root' })
export class WorkflowAgentsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/workflow-agents`;
  }

  async getWorkflowAgents(): Promise<WorkflowAgent[]> {
    return await this.get<WorkflowAgent[]>('');
  }

  async getWorkflowAgent(id: string): Promise<WorkflowAgent> {
    return await this.get<WorkflowAgent>(id);
  }

  async createWorkflowAgent(agent: WorkflowAgent): Promise<string> {
    return await this.postWithResult<WorkflowAgent, string>('', agent);
  }

  async updateWorkflowAgent(agent: WorkflowAgent): Promise<void> {
    return await this.put<WorkflowAgent>('', agent);
  }

  async deleteWorkflowAgent(id: string): Promise<void> {
    return await this.delete(id);
  }

  // Evaluation Sets API
  async getWorkflowEvaluationSets(): Promise<WorkflowEvaluationSet[]> {
    return await this.get<WorkflowEvaluationSet[]>('evaluation-sets/');
  }

  async getWorkflowEvaluationSet(id: string): Promise<WorkflowEvaluationSet> {
    return await this.get<WorkflowEvaluationSet>(`evaluation-sets/${id}`);
  }

  async createWorkflowEvaluationSet(evaluationSet: WorkflowEvaluationSet): Promise<string> {
    return await this.postWithResult('evaluation-sets/', evaluationSet);
  }

  async updateWorkflowEvaluationSet(evaluationSet: WorkflowEvaluationSet): Promise<void> {
    return await this.patch('evaluation-sets', evaluationSet);
  }

  async deleteWorkflowEvaluationSet(id: string): Promise<void> {
    return await this.delete(`evaluation-sets/${id}`);
  }

  // Evaluation Runs API
  async getWorkflowEvaluationRuns(): Promise<WorkflowEvaluationRun[]> {
    const runs = await this.get<WorkflowEvaluationRun[]>('evaluation-runs/');
    runs.forEach(t =>
      ApiConversionHelper.convertDates(t, ['runDate']),
    );
    return runs;
  }

  async getWorkflowEvaluationRun(id: string): Promise<WorkflowEvaluationRun> {
    return await this.get<WorkflowEvaluationRun>(`evaluation-runs/${id}`);
  }

  async executeEvaluationRun(request: ExecuteEvaluationRunRequest): Promise<string> {
    return await this.postWithResult('evaluation-runs/', request);
  }

  async deleteWorkflowEvaluationRun(id: string): Promise<void> {
    return await this.delete(`evaluation-runs/${id}`);
  }
}